import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import AchievementForm from "../components/AchievementForm";
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";

export default function AchievementEdit({ achievement, teamId }: { achievement: any, teamId: number }) {

    const saveAchievement = (data: any) => {
        const requester = new Requester();

        requester.post(requester.getUrl(`api/achievements/${achievement.id}`), data).then((response) => {
            router.visit(`/admin/teams`);
        }).catch((error) => {
            alert("Error saving achievement: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Edit Achievement" />
            <ContentWrapper>
                <AchievementForm onSubmit={saveAchievement} achievement={achievement} teamId={teamId} />
            </ContentWrapper>
        </App >
    )
}